import bootbox from 'bootbox';
import tinymce from "tinymce";

$(document).ready(function(e){
    $('.resend-invitation').on('click', function(e){
        e.preventDefault();
        let id = $(this).data('id');
        $('#invite-modal').modal('show');
    });

    $('.resend-invite').on('click', function(e){
        e.preventDefault();
        let id = $('.resend-invitation').data('id'),
            subject = $('#invite-subject').val(),
            message = $('#invite-body').val(),
            $button = $(this);

        $(this).attr('disabled', true);

        $.ajax({
            type : 'POST',
            url : '/settings/invite/resent',
            data : {
                id, subject, message
            },
            success : function(res){
                if(res){
                    $('#invite-subject').val('');
                    $('#invite-body').val('');
                    $('#invite-modal').modal('hide');
                    bootbox.alert(translation.invitation_sent);
                    $(this).attr('disabled', false);
                }
            }
        })
    });

    $('#invite-colleague').on('click', function(e){
        e.preventDefault();
        $('#invite-modal').modal('show');
    });

    $('#invite-form').on('submit', function(e){
        e.preventDefault();
        let $errors = $('.invite-error'),
            inputs = $(this).serializeArray(),
            payload = {},
            $invite_modal = $('#invite-modal');

        $errors.empty().addClass('d-none');

        inputs.forEach(function(data){
            if (data.name.endsWith('[]')) {
                let key = data.name.slice(0, -2);
                payload[key] = payload[key] || [];
                payload[key].push(data.value);
            } else {
                payload[data.name] = data.value;
            }
        });

        $.ajax({
            type : "POST",
            url : '/settings/invite/user',
            data : payload,
            success : function(res){
                if(res.sent){
                    bootbox.alert(res.message);
                    for (let key in payload) {
                        $invite_modal.find(`input[name="${key}"]`).val('');
                    }
                    $invite_modal.modal('hide');

                    let $step = $(`.wizard-section .step[data-action="invite-colleagues"]`);
                    $step.addClass('done');
                }
            },
            error: function(res){
                let errors = res.responseJSON.errors;
                for (let key in errors) {
                    let value = errors[key];
                    $(`.invite-error[data-id="${key}"]`).html(value).removeClass('d-none');
                }
            }
        })
    });

    $('#edit-profile').on('click', function(e){
        e.preventDefault();
        $('#user-modal').modal('show');
    });

    $('#xml-export').on('click', function(e){
        e.preventDefault();
        $('#exports-modal').modal('show');
    });

    $('#edit-user-form').on('submit', function(e){
        e.preventDefault();
        let $errors = $('.edit-user-error'),
            inputs = $(this).serializeArray(),
            payload = {},
            $edit_user_modal = $('#user-modal');

        $errors.empty().addClass('d-none');

        inputs.forEach(function(data){
            payload[data.name] = data.value;
        });

        $.ajax({
            type : "POST",
            url : '/settings/users',
            data : payload,
            success : function(res){
                if(res.updated){
                    toastr.success(res.message);
                    $edit_user_modal.modal('hide');

                    let $step = $(`.wizard-section .step[data-action="user-profile-setup"]`);
                    $step.addClass('done');
                }
            },
            error: function(res){
                let errors = res.responseJSON.errors;
                for (let key in errors) {
                    let value = errors[key];
                    $(`.edit-user-error[data-id="${key}"]`).html(value).removeClass('d-none');
                }
            }
        })
    });

    $('#profile-picture, #signature-picture').on('change', function(e){
        const id = $(e.target.id),
            file = $(this)[0].files[0],
            validImageTypes = ['image/gif', 'image/jpeg', 'image/png'],
            $hidden_input = $(this),
            slug = $(this).attr('data-slug'),
            $edit_image_holder = $('.edit-image-holder'),
            $profile_picture =  $('.profile-image'),
            $signature = $('.signature-image');

        if(file){
            if(validImageTypes.includes(file.type)){
                let formData = new FormData();
                formData.append('image', file);

                $.ajax({
                    type : 'POST',
                    url : `/settings/users/${slug}`,
                    processData: false,
                    contentType: false,
                    data : formData,
                    success : function(res){
                        let src = res + '?' + Math.random();

                        if(slug === 'image'){
                            $profile_picture.attr('src', src);
                            $edit_image_holder.css('background-image', `url('${src}')`);
                        }else{
                            $signature.attr('src', src);
                        }
                        $hidden_input.val('');
                    },
                    error: function(res){
                        $hidden_input.val('');
                        alert('Something went wrong!');
                    }
                });
            }else{
                $hidden_input.val('');
                alert('Invalid file type');
            }
        }
    });

    $('.remove-profile-image').on('click', function(e){
        $.ajax({
            type : 'DELETE',
            url : '/settings/users/image',
            success : function(res){
                $('.profile-image').attr('src', res);
                $('.edit-image-holder').css('background-image', `url('${res}')`);
                $("#profile-picture").val('');
            },
            error: function(res){
                alert('Something went wrong!');
            }
        });
    });

    $('.remove-signature-image').on('click', function(e){
        $.ajax({
            type : 'DELETE',
            url : '/settings/users/signature',
            success : function(res){
                $('.signature-image').attr('src', res);
                $("#signature-picture").val('');
            },
            error: function(res){
                alert('Something went wrong!');
            }
        });
    });

    $('.upload-profile-image').click(function(e){
        e.preventDefault();
        $('#profile-picture').click();
    });

    $('.upload-signature-image').click(function(e){
        e.preventDefault();
        $('#signature-picture').click();
    });

    if(! /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        $('.user-tooltip').tooltip({
            classes: {
                "ui-tooltip": "user-tooltip-class"
            },
            content: function(e) {
                let template = $(this).find('.template-content').html();
                return `${template}`;
            }
        });

        $('.manage_column_icon').tooltip({
            classes: {
                "ui-tooltip": "edit-icon-tooltip-class"
            },
            content: function(e) {
                let template = $(this).find('.template-content').html();
                return `${template}`;
            }
        });
    }

    $(document).on('click', '.search-dropdown', function (e) {
        e.stopPropagation();
    });

    $('#save-email-sig').on('click', function(e){
        let signature = tinymce.activeEditor.getContent();
        $.ajax({
            type : 'POST',
            url : '/settings/users/email/signature',
            data : {
                signature
            },
            success : function(res){
                toastr.success('Email signature updated');
            }
        })
    });
});